import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { ThemedAsset, assetIds } from "nemuru-components";
import React, { useState } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../../../../config/config";
import ResponsiveLayout from "../../../../../../../shared/components/ResponsiveLayout";
import IconTitle from "../../../../../../../shared/components/IconTitle";
import Text from "../../../../../../../shared/components/Text";

export const FlywireMethod = ({ onSubmitForm }) => {
  const { palette, customBorderRadius, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);
    onSubmitForm();
  };

  return (
    <Container
      style={{
        padding: "0 1rem",
        height: "100%",
      }}
    >
      <ResponsiveLayout>
        <Box>
          <Box style={{ height: isScreenXs ? "10vh" : "7vh" }} />
          <IconTitle
            className="appear-anim"
            icon={
              <ThemedAsset
                id={assetIds.ICON_MONEY}
                width={ICON_TITLE_HEIGHT}
                height={ICON_TITLE_HEIGHT}
                style={{ color: palette.secondary.main }}
              />
            }
            title={<Text tId={"ALTERNATIVE_PAYMENT_METHOD"} />}
            subtitle={<Text tId="INFORMATION" />}
          />
          <Box mt={5}>
            <Typography variant={"body2"}>
              <Text tId={"ALTERNATIVE_PAYMENT_METHOD_EXPLANATION"} />
            </Typography>
          </Box>
        </Box>
        <Box
          style={{ width: "100%" }}
          borderRadius={customBorderRadius.button}
          id="main-button-container"
        >
          <Box
            mt={4}
            height={50}
            style={{
              width: "100%",
            }}
          >
            <Button
              loading
              style={{
                width: "100%",
                height: 48,
              }}
              className="progression"
              variant="contained"
              color="primary"
              onClick={() => handleSubmit()}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={18} color={"secondary"} />
              ) : (
                <Text tId="SELECT_THIS_PAYMENT_METHOD" />
              )}
            </Button>
          </Box>
        </Box>
      </ResponsiveLayout>
    </Container>
  );
};
